var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "loading__wrap" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.flag,
            expression: "flag",
          },
        ],
        staticClass: "loading",
      },
      [_vm._m(0)]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "loading__inner" }, [
      _c("i", { staticClass: "loading__icon" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }